/**
 * SoftShape — amorphous blob for background decoration
 */

import { motion } from 'framer-motion';
import { kidPalette } from '../../styles/kidPalette';

interface SoftShapeProps {
  color?: string;
  size?: number;
  variant?: 'blob1' | 'blob2' | 'blob3';
  className?: string;
}

const blobPaths = {
  blob1: 'M44.5,3.5Q57,7,63,19.5Q69,32,61.5,47Q54,62,39,63Q24,64,14,52Q4,40,7.5,25.5Q11,11,27.5,4.5Q44,0,44.5,3.5Z',
  blob2: 'M42,5Q55,10,65,22Q75,34,66,49Q57,64,41,62.5Q25,61,14.5,49.5Q4,38,9,24Q14,10,28,5Q42,0,42,5Z',
  blob3: 'M45,6Q56,12,62.5,25Q69,38,60,51Q51,64,37,63Q23,62,13,50Q3,38,8.5,24.5Q14,11,29.5,6Q45,1,45,6Z',
};

export default function SoftShape({
  color = kidPalette.violet,
  size = 200,
  variant = 'blob1',
  className = '',
}: SoftShapeProps) {
  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 70 70"
      fill="none"
      className={`pointer-events-none ${className}`}
      animate={{ scale: [1, 1.05, 1], rotate: [0, 3, 0] }}
      transition={{ repeat: Infinity, duration: 8, ease: 'easeInOut' }}
    >
      <path d={blobPaths[variant]} fill={color} opacity={0.12} />
    </motion.svg>
  );
}
